import { useState, useContext } from "react";

import { Photo } from "../interfaces/file";

import { gql } from "apollo-boost";

import Client from "../services/apollo";
import { AppContext } from "../base/AppContext";

const mutation = gql`
  mutation uploadImage($photo: String!) {
    uploadPhoto(photo: $photo) {
      photo
    }
  }
`;

export function useTransfer() {
  const { refreshUser } = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const upload = async (file: Photo) => {
    setLoading(true);
    Client.mutate({
      mutation,
      variables: {
        photo: file.base64,
      },
    })
      .then(() => {
        setLoading(false);
        refreshUser();
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  };

  return {
    upload,
    loading,
    error,
  };
}
